var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FetchContainer',{attrs:{"endpoints":_vm.endpoints},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('NewContactLine',{attrs:{"data":slotProps.data,"refetch":slotProps.fetch}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }